import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { Store } from "@/interfaces/store.interface";
import userApi from "@/api/user";
import { Dropdown } from "primereact/dropdown";
import {
  resolveSelectedStore,
  persistSelectedStore,
} from "@/utils/store-context";

const StoreDropdown = () => {
  const searchParams = useSearchParams();
  const [stores, setStores] = useState<Store[]>([]);
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);

  useEffect(() => {
    userApi
      .getMe()
      .then((userData) => {
        if (userData) {
          setStores(userData.data.stores || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, []);

  // Re-run whenever the stores list is loaded OR the URL query params change.
  // useSearchParams() is the correct hook for tracking ?storeName changes.
  useEffect(() => {
    const resolved = resolveSelectedStore(stores);
    if (resolved) {
      setSelectedStore(resolved);
      // Persist full Store object (never partial) so future navigations are correct.
      persistSelectedStore(resolved);
    }
  }, [stores, searchParams]);

  const handleStoreChange = (store: Store) => {
    setSelectedStore(store);
    persistSelectedStore(store);
    window.location.reload();
  };

  return (
    <Dropdown
      options={stores}
      dataKey="storeName"
      optionLabel="storeName"
      placeholder="Select Store"
      className="w-72"
      value={selectedStore}
      onChange={(e) => handleStoreChange(e.value)}
    />
  );
};

export default StoreDropdown;

